/* eslint-disable no-console */

import {
  NotificationAPIResponse,
  NotificationStateTypeConstants,
  UnreadNotificationApiResponse
} from 'vrlcm-gui-types';
import { Http, mapNotificationDTO } from 'vrlcm-gui-utils';
import { NotificationApiUri } from './uri';

export class NotificationApi {
  public static fetchUnreadNotificationCount(
    postInitFunction?: (cancelFunction: () => void) => void
  ): Promise<number> {
    return Http.get(NotificationApiUri.GET_UNREAD_NOTIFICATION_COUNT_URL)
      .then(res => res.data)
      .catch(err => {
        // Error occurs if the engine is down.
        console.log(
          'Error : Notification count API has response with an error, returning 0 for now. error - ',
          err
        );
        return 0;
      });
  }
  public static fetchUnreadNotifications(
    postInitFunction?: (cancelFunction: () => void) => void
  ): Promise<UnreadNotificationApiResponse> {
    return Http.get(NotificationApiUri.GET_TRUNCATED_NOTIFICATIONS_URL)
      .then(res => res.data)
      .then((data: UnreadNotificationApiResponse) => ({
        ...data,
        notificationDTOs: data.notificationDTOs.map(mapNotificationDTO)
      }));
  }
  public static fetchAllNotifications(
    pageNumber: number,
    pageSize: number,
    postInitFunction?: (cancelFunction: () => void) => void
  ): Promise<NotificationAPIResponse> {
    return Http.get(
      NotificationApiUri.GET_ALL_NOTIFICATIONS_URL(pageNumber, pageSize)
    )
      .then(res => res.data)
      .then((data: NotificationAPIResponse) => ({
        ...data,
        content: data.content.map(mapNotificationDTO)
      }));
  }
  public static updateNotificationStatusAsRead(
    vmid: string,
    postInitFunction?: (cancelFunction: () => void) => void
  ) {
    return Http.put(NotificationApiUri.UPDATE_NOTIFICATIONS_URL(vmid), {
      notificationStateRequestBody: NotificationStateTypeConstants.READ
    });
  }
  public static updateNotificationStatusAsCleared(
    vmid: string,
    postInitFunction?: (cancelFunction: () => void) => void
  ) {
    return Http.put(NotificationApiUri.UPDATE_NOTIFICATIONS_URL(vmid), {
      notificationStateRequestBody: NotificationStateTypeConstants.ARCHIVED
    });
  }
  public static clearAllNotifications(
    postInitFunction?: (cancelFunction: () => void) => void
  ) {
    return Http.post(NotificationApiUri.CLEAR_ALL_NOTIFICATIONS_URL);
  }
  public static markAllReadNotifications(
    postInitFunction?: (cancelFunction: () => void) => void
  ) {
    return Http.post(NotificationApiUri.READ_ALL_NOTIFICATIONS_URL);
  }
}
